export default {"src":"/_next/static/media/postepay-gray.e3959eed.svg","height":11,"width":52,"blurWidth":0,"blurHeight":0};